import { ExternalLinkWithHiddenParams } from './ExternalLinkWithHiddenParams';

export default ExternalLinkWithHiddenParams;
